import {Inject, Injectable} from '@angular/core';
import {EntitiesChannel} from "../../../commons/angular/classes/entities-channel";
import {VisitPlanModel} from "../../models/visit-plan.model";
import {VisitScheduleModel} from "../../models/visit-schedule.model";

@Injectable({providedIn: 'root'})
export class VisitScheduleChannelService extends EntitiesChannel<VisitScheduleModel> {

  constructor(@Inject('firebaseService') protected firebaseService) {
    super()
  }

  getChannelName(): String {
    return "visitSchedule_changed";
  }

  getPartialChannelName(): String {
    return "";
  }

  getCreateChannelName(): String {
    return "visitSchedule_created";
  }

}
